/**
 * Helper function to start monitoring the scroll event and converting them into
 * PDF.js friendly one: with scroll debounce and scroll direction.
 */
export function watchScroll(viewAreaElement, callback) {
    const state = {
        down: true,
        lastY: viewAreaElement.scrollTop,
        lastX: viewAreaElement.scrollLeft,
        scrollHeight: viewAreaElement.scrollHeight
    };
    let rAF = null;
    viewAreaElement.addEventListener('scroll', debounceScroll, true);
    return state;
    function debounceScroll(event) {
        if (rAF) {
            return;
        }
        // schedule an invocation of scroll for next animation frame.
        rAF = window.requestAnimationFrame(() => {
            rAF = null;
            const top = viewAreaElement.scrollTop;
            const scrollHeight = viewAreaElement.scrollHeight;
            const lastY = state.lastY;
            if (top !== lastY) {
                state.down = top > lastY;
            }
            state.lastY = top;
            state.scrollHeight = scrollHeight;
            callback(event, state);
        });
    }
}
export function getViewState(views, viewportHeight, viewportWidth, scroll, sortByVisibility = false) {
    const top = scroll.lastY;
    const bottom = top + viewportHeight;
    // const left = scrollEl.scrollLeft
    // const right = left + scrollEl.clientWidth
    const firstVisibleElementIndex = views.findIndex(item => item.bottom > top);
    const visible = [];
    for (let i = 0; i < views.length; i++) {
        const view = views[i];
        const viewHeight = view.height;
        const heightFromTop = view.top;
        const isViewBelowViewport = view.top > bottom;
        view.viewState.percent = 0;
        view.viewState.pixels = 0;
        if (i < firstVisibleElementIndex) {
            continue;
        }
        if (isViewBelowViewport) {
            break;
        }
        if (view.parentView && !view.parentView.isExpanded) {
            continue;
        }
        // currentWidth = element.offsetLeft + element.clientLeft
        // viewWidth = element.clientWidth
        // if (currentWidth + viewWidth < left || currentWidth > right) {
        //   continue
        // }
        const hiddenHeight = Math.max(0, top - heightFromTop) + Math.max(0, heightFromTop + viewHeight - bottom);
        const visibleHeight = viewHeight - hiddenHeight;
        const percentHeight = ((visibleHeight * 100) / viewHeight) | 0;
        view.viewState.percent = percentHeight;
        view.viewState.pixels = visibleHeight;
        visible.push({
            id: i,
            // x: currentWidth,
            y: heightFromTop,
            view: view,
            percent: percentHeight,
            pixels: visibleHeight
        });
    }
    const first = visible[0];
    const last = visible[visible.length - 1];
    if (sortByVisibility) {
        visible.sort((a, b) => {
            let pc = a.percent - b.percent;
            if (Math.abs(pc) > 0.001) {
                return -pc;
            }
            return a.id - b.id;
        });
    }
    const secondItem = first ? visible.find(view => view.id === first.id + 1) : null;
    const isScrollPositionBottom = scroll.lastY !== 0 && top + viewportHeight === scroll.scrollHeight;
    const focus = isScrollPositionBottom
        ? last
        : first.percent > 80
            ? first
            : secondItem && secondItem.percent > first.percent
                ? secondItem
                : first;
    return { first, last, views: visible, top, bottom, focus, scroll };
}
//# sourceMappingURL=ui-utils.js.map